import { ManagementNoteModal, PortalNoteModal } from '@apps-common/apps/portal/pages/units/pages/manage/pages/notes/components'
import { ModalButton } from '@apps-common/components/modals'
import { commonIcons } from '@apps-common/config/icons'

import { UnitNoteType } from '../Index'

interface IProps {
  type: UnitNoteType
  entityId: string
  loading: boolean
}

export const UnitNoteCreateButton: React.FC<IProps> = ({ type, entityId, loading }) => {
  const AddIcon = commonIcons.add

  return (
    <ModalButton
      component={type === 'management' ? ManagementNoteModal : PortalNoteModal}
      disabled={loading}
      componentProps={{
        entityId
      }}
      classes='relative action-success w-[36px] h-[36px] rounded-[20px] flex items-center justify-center rounded-full'
      confirmCallback={() => {}}
      cancelCallback={() => {}}
    >
      <AddIcon className='text-[1.35rem]' />
    </ModalButton>
  )
}
